module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-12-3103beddf2023c2819028333fed92ff2.svg";